import HttpService from './HttpService';

export async function getUser() {
  try {
    const response = await HttpService.get('/v2/user');
    return response.data;
  } catch (e) {
    throw e;
  }
}

export async function patchUser(body) {
  try {
    const response = await HttpService.patch('/user/web', body);
    return response.data;
  } catch (e) {
    throw e;
  }
}
